import React from 'react';
import Spinner from './iconSvgs/spinner';

interface LoadingSpinnerProps {
  className?: string;
  size?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className = '', size = '32' }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80" style={{ minHeight: '400px' }}>
      <Spinner className={className} size={size} />
    </div>
  );
};

export default LoadingSpinner;
